import gql from 'graphql-tag'

export const GET_ORGANIZATION_STOCK_BY_ID = gql`
    query ($id: uuid!){
        OrganizationStock: OrganizationStock(where: {organizationId: {_eq: $id}}, order_by: {ProductUnit: {unit: desc}}){
            id
            organizationId
            locationId
            productId
            quantity
            reservedQuantity
            unitId
            totalQuantityInPackets
            created_at
            updated_at
            ProductUnit{
                id
                unit
            }
        }
    }`

export const GET_ORGANIZATION_STOCK_INWARD = gql`
    query ($fromId:uuid!,$toId:uuid!,$unitId:uuid!){
        FromOrganizationStock:OrganizationStock(where: {organizationId: {_eq: $fromId}, unitId: {_eq: $unitId}}, order_by: {ProductUnit: {unit: desc}}){
            id
            organizationId
            locationId
            productId
            quantity
            unitId
            totalQuantityInPackets
        },
        ToOrganizationStock:OrganizationStock(where: {organizationId: {_eq: $toId}, unitId: {_eq: $unitId}}, order_by: {ProductUnit: {unit: desc}}){
            id
            organizationId
            locationId
            productId
            quantity
            unitId
            totalQuantityInPackets
        }
    }`
export const GET_ORGANIZATION_DUE_BY_ID = gql`
    query ($id:uuid!){
        Organizations(where:{ id:{ _eq: $id}}){
            id
            totalDueAmount
        }}`
